export enum DimensionUnit {
  Mm = "mm",
  Cm = "cm",
  M = "m",
  In = "in",
  Ft = "ft",
  Yd = "yd",
}
